import { Launch } from '@/types';

const pathnameFor = (v: Launch) => {
  switch (v.namespace) {
    case 'city':
      return v.id ? `/city/${v.id}/` : '/city/';
    case 'integrated':
      return v.id ? `/integrated/${v.id}/` : '/integrated/';
    case 'workspace':
      return v.id ? `/workspaces/${v.id}` : '/workspaces/';
    case 'inventory':
      return v.id ? `/inventories/${v.id}` : '/inventories/';
    case 'community-inventory':
      return v.id ? `/communities/${v.id}` : '/communities/';
    case 'dataset':
      return v.id ? `/datasets/${v.id}` : '/datasets/';
    case 'pathways':
      return '/pathways/';
    case 'bill-management':
      return v.id ? `/bill-management/${v.id}` : '/bill-management/';
    // Landing sentinels (not products): a target with no licensed products, or
    // doorway being unavailable. They map to zoo's own routes.
    case 'no-products':
      return '/no-products';
    case 'unavailable':
      return '/settings';
  }
};

// Where a shared object lives, by the namespace diplomat names it with. This
// is a different vocabulary from Launch above: a share names a single entity,
// not a product to land in. A namespace with no entry here has no destination
// in zoo yet — the caller keeps its own ground rather than being sent
// somewhere wrong.
const sharedPathnames: Record<string, (key: string) => string> = {
  // Served by suit under the `/audits` prefix it claims from zoo at the CDN
  // (kinesisptyltd/suit#3710); until that ships this path does not resolve.
  // The same destination the no-products page links its shared disclosures to.
  disclosure: (key) => `/audits/disclosures/${key}`,
};

const sharedPathnameFor = (v?: { namespace: string; key: string }) =>
  v?.namespace ? sharedPathnames[v.namespace]?.(v.key) : undefined;

const launch = (v: Launch | undefined, replace: boolean) => {
  const l: Launch = v ? v : { namespace: 'workspace' };
  const pathname = pathnameFor(l);
  if (replace) {
    window.location.replace(pathname);
  } else {
    window.location.assign(pathname);
  }
};

export { launch, sharedPathnameFor };
